module.exports = __webpack_public_path__ + "static/media/bcm.8d2504cc.png";